/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_OwnerInputs */

const en_household_owner = /** @type {(inputs: Household_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

const de_household_owner = /** @type {(inputs: Household_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaber`)
};

/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Household_OwnerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const household_owner = /** @type {((inputs?: Household_OwnerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_OwnerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_household_owner(inputs)
	return en_household_owner(inputs)
});